import { render, staticRenderFns } from "./PercentageRing.vue?vue&type=template&id=421c44f0&"
import script from "./PercentageRingVue.ts?vue&type=script&lang=ts&"
export * from "./PercentageRingVue.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports